<div class="row mt-2 no-gutters">
  <div class="col">
    <small *ngIf="accountCategory== 'RENTAL_FLEET' && isAdmin">
      <a [routerLink]="['/rental-fleet']" class="text-secondary">Admin Console</a>
    </small>
    <small *ngIf="accountCategory== 'RENTAL_FLEET' && isDeveloper">
      <a [routerLink]="['/rental-fleet']" class="text-secondary">Developer Portal</a>
    </small>
    <small *ngIf="(accountCategory == 'FLEET_MANAGEMENT_COMPANY' || accountCategory == 'MOBILITY_COMPANY' || accountCategory == 'FIELD_SERVICE_COMPANY') && (isAdmin || isFinanceAdmin)">
      <a [routerLink]="['/commercial-fleet']" class="text-secondary">Admin Console</a>
    </small>
    <small *ngIf="(accountCategory== 'FLEET_MANAGEMENT_COMPANY' || accountCategory == 'MOBILITY_COMPANY' || accountCategory == 'FIELD_SERVICE_COMPANY') && isDeveloper">
      <a [routerLink]="['/commercial-fleet']" class="text-secondary">Developer Portal</a>
    </small>
  </div>
</div>


<div *ngIf="!showSearchResult" class="row align-items-center justify-content-center home-container no-gutters">
  <div class="col pl-0 pr-0">
    <div *ngIf="isAdmin" class="row text-center ml-1 mr-1 mt-4">
      <!-- <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/dashboard.png" alt="accounts"
          routerLink="/commercial-fleet-dashboard" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Dashboard</span><br>
        <span class="font-nissan-brand-w01-light font-12">View fleet status and insights</span>
      </div> -->
      <!-- <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/usage.png" alt="usage" routerLink="/usage" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Usage</span><br>
        <span class="font-nissan-brand-w01-light font-12">View service usage</span>
      </div> -->
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/user.png" alt="accounts" routerLink="/account-management" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Account Management</span><br>
        <span *ngIf="utilService.isHideLocation" class="font-nissan-brand-w01-light font-12">Manage vehicles and packages</span>
        <span *ngIf="!utilService.isHideLocation" class="font-nissan-brand-w01-light font-12">Manage vehicles, packages and locations</span>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/usage.png" alt="invoices" routerLink="/invoices" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Invoices</span><br>
        <span class="font-nissan-brand-w01-light font-12">View invoices</span>
      </div>
      <!-- <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/idea.png" alt="insights"
          routerLink="/commercial-fleet/insights" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Insights</span><br>
        <span class="font-nissan-brand-w01-light font-12">View fleet performance</span>
      </div> -->
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/users.png" alt="consent management"
          routerLink="/admin-roles" /><br>
        <span class="font-nissan-brand-w01-bold font-14">User Roles</span><br>
        <span class="font-nissan-brand-w01-light font-12">Add or manage users</span>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/question.png" alt="admin roles" routerLink="/support" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Support</span><br>
        <span class="font-nissan-brand-w01-light font-12">Access support services</span>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/gear.png" alt="service Packaging" routerLink="/settings" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Settings</span><br>
        <span class="font-nissan-brand-w01-light font-12">Manage account & brand settings</span>
      </div>
      <!-- <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/developer-access.png" alt="developer access"
          (click)="openDeveloperAccess()" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Developer Access</span><br>
        <span class="font-nissan-brand-w01-light font-12">View and manage API access</span>
      </div> -->
      <!-- <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/question.png" alt="Support" routerLink="/support" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Support</span><br>
        <span class="font-nissan-brand-w01-light font-12">Access support services</span>
      </div> -->
    </div>
    <div *ngIf="isDeveloper" class="row text-center ml-1 mr-1 mt-4">
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/developer-access.png" alt="developer access"
          (click)="apiAccess.openDeveloperAccess()" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Developer Access</span><br>
        <span class="font-nissan-brand-w01-light font-12">View and manage API access</span>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/developer-access.png" alt="Swagger"
          routerLink="/swagger-ui"/><br>
        <span class="font-nissan-brand-w01-bold font-14">Developer APIs</span><br>
        <span class="font-nissan-brand-w01-light font-12">View and try APIs</span>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/question.png" alt="Support" routerLink="/support" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Support</span><br>
        <span class="font-nissan-brand-w01-light font-12">Access support services</span>
      </div>
    </div>
    <div *ngIf="isFinanceAdmin" class="row text-center ml-1 mr-1 mt-4 no-gutters">
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/usage.png" alt="invoices" routerLink="/invoices" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Invoices</span><br>
        <span class="font-nissan-brand-w01-light font-12">View invoices</span>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/question.png" alt="Support" routerLink="/support" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Support</span><br>
        <span class="font-nissan-brand-w01-light font-12">Access support services</span>
      </div>
    </div>
    <div *ngIf="!isAdmin && !isDeveloper" class="row text-center ml-5 mr-5 pt-4">
      <h4 class="text-muted">Access Denied! You don't have the permission to access this portal.</h4>
    </div>
  </div>
</div>

<div *ngIf="showSearchResult" class="row align-items-center justify-content-center no-gutters">
  <div class="col-12">
    <app-search-results [locationList]="searchedLocationList" [servicePackageList]="searchedServicePackageList"
      [vehicleList]="searchedVehicleList" (selectedItemEmitter)="onSearchItemDetail($event);"
      (selectedItemCloseEmitter)="selectedSearchItemForView=null;" #searchResult></app-search-results>
  </div>
</div>



<!-- Modal API Access -->
<developer-access #apiAccess></developer-access>

<!-- TnC Model -->
<ncc-tnc></ncc-tnc>